// extracted by mini-css-extract-plugin
export default {"title":"IZsqX1ZFVnEp5H0oEAWB"};